import { Form, Input, Select } from "antd";
import Modal from "antd/es/modal/Modal";
import { t } from "i18next";
import React, { SetStateAction } from "react";

const AddSystemTermModal = ({
  open,
  setOpen,
  isLoading,
  onAdd,
}: {
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  isLoading: boolean;
  onAdd: ({ data }: any) => Promise<any>;
}) => {
  const [form] = Form.useForm();
  const handleClose = () => {
    form.resetFields();
    setOpen(false);
  };
  const onFinish = async (e: any) => {
    const formData = new FormData();
    formData.append("name_ar", e.name_ar);
    formData.append("name_en", e.name_en);
    formData.append("type", e.type);

    await onAdd({ data: formData });
    form.resetFields();
  };
  return (
    <Modal
      key={"addSystemTerm"}
      title={t("add_system_term")}
      open={open}
      width={400}
      centered
      bodyStyle={{ padding: 20 }}
      destroyOnClose
      onCancel={() => handleClose()}
      confirmLoading={isLoading}
      onOk={() => {
        form.submit();
      }}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{}}
        labelCol={{ span: 24 }}
        validateMessages={{
          required: t("please_input") + " ${label}!",
        }}
      >
        <Form.Item
          name={"name_ar"}
          label={t("arabic_name")}
          rules={[{ required: true }]}
          required
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={"name_en"}
          label={t("english_name")}
          rules={[{ required: true }]}
          required
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="type"
          label={t("type")}
          rules={[{ required: true }]}
          required
        >
          <Select>
          <Select.Option value="in">{t("in_system_terms")}</Select.Option>
            <Select.Option value="out">{t("out_system_terms")}</Select.Option>
            <Select.Option value="both">{t("both_system_terms")}</Select.Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddSystemTermModal;
